import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import NewVehicle from "./NewVehicle"

const AddVehicle = ({ asModal = false, closeModalHandler }) => {
  return (
    <NewVehicle asModal={asModal} closeModalHandler={closeModalHandler} serviceRequest={true} />
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let vehicle = state.selectedVehicle.selectedVehicle || {}
  let activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}

  return {
    user: user,
    vehicle: vehicle,
    activeVehicle: activeVehicle
  }
}

export default withRouter(connect(mapStateToProps)(withTranslation("vehicleDetails")(AddVehicle)))
